import { useContext, useEffect, useMemo, useState } from 'react'
import objectPath from 'object-path'
import { useRouteMatch, useLocation } from 'react-router-dom'
import MultiScore from './scoreChart/MultiScore'
import SingleScore from './scoreChart/SingleScore'
import { DesignContext } from 'contexts/DesignContext'
import { checkConditionApi, setApi } from '../action/Api'
import httpClient from 'utility/httpClient.util'

const ScoreChart = (props) => {
  const { uischema } = props
  const designContext = useContext(DesignContext)
  const { jsonForm, elementAction } = designContext
  const scoreAction = objectPath.get(uischema, 'scoreAction') || {}
  const actionValidate = objectPath.get(scoreAction, 'validate') || {}
  const [validateConfig, setValidateConfig] = useState({})
  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const pathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const queryParams = Object.fromEntries([...urlSearchParams])
  const urlParams = { ...pathParams, ...queryParams }
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const fullConfig = objectPath.get(uischema, 'scoreConfig') || []
  const timeChart = useMemo(() => {
    return fullConfig.find(({ isTime, enabled }) => isTime && enabled) || {}
  }, [])

  const loadConfig = async () => {
    if (!actionValidate?.isEnabled) return
    let requestData = { urlParams, datasourceValue }
    let { apiGroup = [] } = actionValidate
    let promiseList = []
    let formData = jsonForm.formData
    apiGroup.map(async (item) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = {}
        let data = null
        let status = null
        let message = ''
        let isGet = checkConditionApi(
          item,
          urlParams,
          formData,
          datasourceValue
        )
        if (!isGet) return reject({ item, formData })
        let api = setApi(item, formData, requestData)
        if (!api) return resolve(formData)
        let { headers = [] } = item
        let config = {}
        if (headers.length > 0) {
          headers.forEach(({ key, value }) => {
            if (key) {
              objectPath.set(config, `headers.${key}`, value)
            }
          })
        }
        response = await httpClient
          .get(api, config)
          .then((data) => data)
          .catch(function (error) {
            let errorResponse = {
              status: 500,
              message: 'There was an error!',
              data: null,
            }
            if (error.response) {
              errorResponse = {
                status: error.response.status,
                message: error.response.data,
                data: null,
              }
            }
            return errorResponse
          })
        data = response.data
        message = response.message
        status = response.status
        if (status >= 400) return reject({ data, item, response })
        resolve({ data, item, response })
      })
        .then((values) => values)
        .catch((error) => console.error('There was an error!', error))
      promiseList.push(promise)
    })
    await Promise.all(promiseList).then((resolveData) => {
      resolveData.forEach((res) => {
        if (res) {
          let { data = null, item } = res
          if (item) {
            if (item.dataKey) {
              data = objectPath.get(data, item.dataKey)
            }
            setValidateConfig({ ...validateConfig, ...data })
          }
        }
      })
    })
  }

  useEffect(() => loadConfig(), [])

  const isCurrentTime = timeChart.isCurrentTime

  if (isCurrentTime) {
    return (
      <SingleScore
        {...props}
        isReadOnly={isReadOnly}
        isLocked={isLocked}
        validateConfig={validateConfig}
      />
    )
  }

  return (
    <MultiScore
      {...props}
      isReadOnly={isReadOnly}
      isLocked={isLocked}
      validateConfig={validateConfig}
    />
  )
}

export default ScoreChart
